import { extend } from "vee-validate";
import {
  required,
  email,
  alpha_num,
  length,
  min_value,
  max_value,
  regex,
  numeric,
  alpha_spaces
} from "vee-validate/dist/rules";

export function initValidation() {
  extend("required", required);
  extend("alpha_num", alpha_num);
  extend("length", length);
  extend("email", email);
  extend("regex", regex);
  extend("min", min_value);
  extend("max", max_value);
  extend("numeric", numeric);
  extend("alpha_spaces", alpha_spaces);

  // Add the required rule
  extend("required", {
    ...required,
    message: "This field is required"
  });

  // Add the email rule
  extend("email", {
    ...email,
    message: "This field must be a valid email"
  });

  // Add the numeric rule
  extend("numeric", {
    ...numeric,
    message: "This field must be a valid numeric"
  });

  // Add the alpha_spaces rule
  extend("alpha_spaces", {
    ...alpha_spaces,
    message: "This field must be a valid name"
  });

  // Add the alpha_spaces rule

  extend("alpha_num_space", {
    message: "{_field_} may only contain letters, numbers and spaces",
    validate: value => {
      return /^[a-zA-Z0-9 ]+$/.test(value);
    }
  });
}
